import{defineMessages}from'react-intl';

export default defineMessages({
eventContact:{
id:'i18n.EventDetailsTab.eventContact',
defaultMessage:'Brand Contact'},

store:{
id:'i18n.EventDetailsTab.store',
defaultMessage:'Store'},

district:{
id:'i18n.EventDetailsTab.district',
defaultMessage:'District'},

region:{
id:'i18n.EventDetailsTab.region',
defaultMessage:'Region'},

ultaEventManager:{
id:'i18n.EventDetailsTab.ultaEventManager',
defaultMessage:'Ulta Event Manager'},

attributes:{
id:'i18n.EventDetailsTab.attributes',
defaultMessage:'Attributes'},

salesGoal:{
id:'i18n.EventDetailsTab.salesGoal',
defaultMessage:'Sales Goal'},

stockLift:{
id:'i18n.EventDetailsTab.stockLift',
defaultMessage:'Stock Lift'},

numberOfArtists:{
id:'i18n.EventDetailsTab.numberOfArtists',
defaultMessage:'Number of Artists'},

appointmentLength:{
id:'i18n.EventDetailsTab.appointmentLength',
defaultMessage:'Appointment Length'},

prepay:{
id:'i18n.EventDetailsTab.prepay',
defaultMessage:'Prepay'},

hourText:{
id:'i18n.EventDetailsTab.hourText',
defaultMessage:'hours'},

atTheRate:{
id:'i18n.EventDetailsTab.atTheRate',
defaultMessage:'@'},

description:{
id:'i18n.EventDetailsTab.description',
defaultMessage:'Description'},

showMore:{
id:'i18n.EventDetailsTab.showMore',
defaultMessage:'Show More'},

minutes:{
id:'i18n.EventDetailsTab.minutes',
defaultMessage:'minutes'},

stockLiftPresent:{
id:'i18n.EventDetailsTab.stockLiftPresent',
defaultMessage:'Yes'},

stockLiftAbsent:{
id:'i18n.EventDetailsTab.stockLiftAbsent',
defaultMessage:'No'},

edit:{
id:'i18n.EventDetailsTab.edit',
defaultMessage:'Edit Event'},

requestCancellation:{
id:'i18n.EventDetailsTab.edit',
defaultMessage:'Request Cancellation'},

viewStockLift:{
id:'i18n.EventDetails.viewStockLift',
defaultMessage:'View Stock Lift'},

addStockLift:{
id:'i18n.EventDetails.addStockLift',
defaultMessage:'Add Stock Lift'},

billableHours:{
id:'i18n.EventDetails.billableHours',
defaultMessage:'Payroll Hours'},

eventDeleted:{
id:'i18n.EventDetails.eventDeleted',
defaultMessage:'Event Deleted'},

eventDeletedYes:{
id:'i18n.EventDetailsTab.eventDeletedYes',
defaultMessage:'Yes'},

eventDeletedNo:{
id:'i18n.EventDetailsTab.eventDeletedNo',
defaultMessage:'No'},

numberOfBrandPartners:{
id:'i18n.EventDetailsTab.numberOfBrandPartners',
defaultMessage:'Number of Brand Partners'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0V2ZW50RGV0YWlsc1RhYi9FdmVudERldGFpbHNUYWIubWVzc2FnZXMuanMiXSwibmFtZXMiOlsiZGVmaW5lTWVzc2FnZXMiLCJldmVudENvbnRhY3QiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwic3RvcmUiLCJkaXN0cmljdCIsInJlZ2lvbiIsInVsdGFFdmVudE1hbmFnZXIiLCJhdHRyaWJ1dGVzIiwic2FsZXNHb2FsIiwic3RvY2tMaWZ0IiwibnVtYmVyT2ZBcnRpc3RzIiwiYXBwb2ludG1lbnRMZW5ndGgiLCJwcmVwYXkiLCJob3VyVGV4dCIsImF0VGhlUmF0ZSIsImRlc2NyaXB0aW9uIiwic2hvd01vcmUiLCJtaW51dGVzIiwic3RvY2tMaWZ0UHJlc2VudCIsInN0b2NrTGlmdEFic2VudCIsImVkaXQiLCJyZXF1ZXN0Q2FuY2VsbGF0aW9uIiwidmlld1N0b2NrTGlmdCIsImFkZFN0b2NrTGlmdCIsImJpbGxhYmxlSG91cnMiLCJldmVudERlbGV0ZWQiLCJldmVudERlbGV0ZWRZZXMiLCJldmVudERlbGV0ZWRObyIsIm51bWJlck9mQnJhbmRQYXJ0bmVycyJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBU0EsY0FBVCxLQUErQixZQUEvQjs7QUFFQSxjQUFlQSxnQkFBZTtBQUM1QkMsYUFBYztBQUNaQyxHQUFJLG1DQURRO0FBRVpDLGVBQWdCLGVBRkosQ0FEYzs7QUFLNUJDLE1BQU87QUFDTEYsR0FBSSw0QkFEQztBQUVMQyxlQUFnQixPQUZYLENBTHFCOztBQVM1QkUsU0FBVTtBQUNSSCxHQUFJLCtCQURJO0FBRVJDLGVBQWdCLFVBRlIsQ0FUa0I7O0FBYTVCRyxPQUFRO0FBQ05KLEdBQUksNkJBREU7QUFFTkMsZUFBZ0IsUUFGVixDQWJvQjs7QUFpQjVCSSxpQkFBa0I7QUFDaEJMLEdBQUksdUNBRFk7QUFFaEJDLGVBQWdCLG9CQUZBLENBakJVOztBQXFCNUJLLFdBQVk7QUFDVk4sR0FBSSxpQ0FETTtBQUVWQyxlQUFnQixZQUZOLENBckJnQjs7QUF5QjVCTSxVQUFXO0FBQ1RQLEdBQUksZ0NBREs7QUFFVEMsZUFBZ0IsWUFGUCxDQXpCaUI7O0FBNkI1Qk8sVUFBVztBQUNUUixHQUFJLGdDQURLO0FBRVRDLGVBQWdCLFlBRlAsQ0E3QmlCOztBQWlDNUJRLGdCQUFpQjtBQUNmVCxHQUFJLHNDQURXO0FBRWZDLGVBQWdCLG1CQUZELENBakNXOztBQXFDNUJTLGtCQUFtQjtBQUNqQlYsR0FBSSx3Q0FEYTtBQUVqQkMsZUFBZ0Isb0JBRkMsQ0FyQ1M7O0FBeUM1QlUsT0FBUTtBQUNOWCxHQUFJLDZCQURFO0FBRU5DLGVBQWdCLFFBRlYsQ0F6Q29COztBQTZDNUJXLFNBQVU7QUFDUlosR0FBSSwrQkFESTtBQUVSQyxlQUFnQixPQUZSLENBN0NrQjs7QUFpRDVCWSxVQUFXO0FBQ1RiLEdBQUksZ0NBREs7QUFFVEMsZUFBZ0IsR0FGUCxDQWpEaUI7O0FBcUQ1QmEsWUFBYTtBQUNYZCxHQUFJLGtDQURPO0FBRVhDLGVBQWdCLGFBRkwsQ0FyRGU7O0FBeUQ1QmMsU0FBVTtBQUNSZixHQUFJLCtCQURJO0FBRVJDLGVBQWdCLFdBRlIsQ0F6RGtCOztBQTZENUJlLFFBQVM7QUFDUGhCLEdBQUksOEJBREc7QUFFUEMsZUFBZ0IsU0FGVCxDQTdEbUI7O0FBaUU1QmdCLGlCQUFrQjtBQUNoQmpCLEdBQUksdUNBRFk7QUFFaEJDLGVBQWdCLEtBRkEsQ0FqRVU7O0FBcUU1QmlCLGdCQUFpQjtBQUNmbEIsR0FBSSxzQ0FEVztBQUVmQyxlQUFnQixJQUZELENBckVXOztBQXlFNUJrQixLQUFNO0FBQ0puQixHQUFJLDJCQURBO0FBRUpDLGVBQWdCLFlBRlosQ0F6RXNCOztBQTZFNUJtQixvQkFBcUI7QUFDbkJwQixHQUFJLDJCQURlO0FBRW5CQyxlQUFnQixzQkFGRyxDQTdFTzs7QUFpRjVCb0IsY0FBZTtBQUNickIsR0FBSSxpQ0FEUztBQUViQyxlQUFnQixpQkFGSCxDQWpGYTs7QUFxRjVCcUIsYUFBYztBQUNadEIsR0FBSSxnQ0FEUTtBQUVaQyxlQUFnQixnQkFGSixDQXJGYzs7QUF5RjVCc0IsY0FBZTtBQUNidkIsR0FBSSxpQ0FEUztBQUViQyxlQUFnQixlQUZILENBekZhOztBQTZGNUJ1QixhQUFjO0FBQ1p4QixHQUFJLGdDQURRO0FBRVpDLGVBQWdCLGVBRkosQ0E3RmM7O0FBaUc1QndCLGdCQUFpQjtBQUNmekIsR0FBSSxzQ0FEVztBQUVmQyxlQUFnQixLQUZELENBakdXOztBQXFHNUJ5QixlQUFnQjtBQUNkMUIsR0FBSSxxQ0FEVTtBQUVkQyxlQUFnQixJQUZGLENBckdZOztBQXlHNUIwQixzQkFBdUI7QUFDckIzQixHQUFJLDRDQURpQjtBQUVyQkMsZUFBZ0IsMEJBRkssQ0F6R0ssQ0FBZixDQUFmIiwiZmlsZSI6IkV2ZW50RGV0YWlsc1RhYi5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBldmVudENvbnRhY3Q6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLmV2ZW50Q29udGFjdCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdCcmFuZCBDb250YWN0JyxcbiAgfSxcbiAgc3RvcmU6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLnN0b3JlJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1N0b3JlJyxcbiAgfSxcbiAgZGlzdHJpY3Q6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLmRpc3RyaWN0JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0Rpc3RyaWN0JyxcbiAgfSxcbiAgcmVnaW9uOiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlsc1RhYi5yZWdpb24nLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnUmVnaW9uJyxcbiAgfSxcbiAgdWx0YUV2ZW50TWFuYWdlcjoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIudWx0YUV2ZW50TWFuYWdlcicsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdVbHRhIEV2ZW50IE1hbmFnZXInLFxuICB9LFxuICBhdHRyaWJ1dGVzOiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlsc1RhYi5hdHRyaWJ1dGVzJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0F0dHJpYnV0ZXMnLFxuICB9LFxuICBzYWxlc0dvYWw6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLnNhbGVzR29hbCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdTYWxlcyBHb2FsJyxcbiAgfSxcbiAgc3RvY2tMaWZ0OiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlsc1RhYi5zdG9ja0xpZnQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU3RvY2sgTGlmdCcsXG4gIH0sXG4gIG51bWJlck9mQXJ0aXN0czoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIubnVtYmVyT2ZBcnRpc3RzJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ051bWJlciBvZiBBcnRpc3RzJyxcbiAgfSxcbiAgYXBwb2ludG1lbnRMZW5ndGg6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLmFwcG9pbnRtZW50TGVuZ3RoJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0FwcG9pbnRtZW50IExlbmd0aCcsXG4gIH0sXG4gIHByZXBheToge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIucHJlcGF5JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1ByZXBheScsXG4gIH0sXG4gIGhvdXJUZXh0OiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlsc1RhYi5ob3VyVGV4dCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdob3VycycsXG4gIH0sXG4gIGF0VGhlUmF0ZToge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIuYXRUaGVSYXRlJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0AnLFxuICB9LFxuICBkZXNjcmlwdGlvbjoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIuZGVzY3JpcHRpb24nLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnRGVzY3JpcHRpb24nLFxuICB9LFxuICBzaG93TW9yZToge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIuc2hvd01vcmUnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU2hvdyBNb3JlJyxcbiAgfSxcbiAgbWludXRlczoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIubWludXRlcycsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdtaW51dGVzJyxcbiAgfSxcbiAgc3RvY2tMaWZ0UHJlc2VudDoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIuc3RvY2tMaWZ0UHJlc2VudCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdZZXMnLFxuICB9LFxuICBzdG9ja0xpZnRBYnNlbnQ6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLnN0b2NrTGlmdEFic2VudCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdObycsXG4gIH0sXG4gIGVkaXQ6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLmVkaXQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnRWRpdCBFdmVudCcsXG4gIH0sXG4gIHJlcXVlc3RDYW5jZWxsYXRpb246IHtcbiAgICBpZDogJ2kxOG4uRXZlbnREZXRhaWxzVGFiLmVkaXQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnUmVxdWVzdCBDYW5jZWxsYXRpb24nLFxuICB9LFxuICB2aWV3U3RvY2tMaWZ0OiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlscy52aWV3U3RvY2tMaWZ0JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1ZpZXcgU3RvY2sgTGlmdCcsXG4gIH0sXG4gIGFkZFN0b2NrTGlmdDoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHMuYWRkU3RvY2tMaWZ0JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0FkZCBTdG9jayBMaWZ0JyxcbiAgfSxcbiAgYmlsbGFibGVIb3Vyczoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHMuYmlsbGFibGVIb3VycycsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdQYXlyb2xsIEhvdXJzJyxcbiAgfSxcbiAgZXZlbnREZWxldGVkOiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlscy5ldmVudERlbGV0ZWQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnRXZlbnQgRGVsZXRlZCcsXG4gIH0sXG4gIGV2ZW50RGVsZXRlZFllczoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIuZXZlbnREZWxldGVkWWVzJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1llcycsXG4gIH0sXG4gIGV2ZW50RGVsZXRlZE5vOiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlsc1RhYi5ldmVudERlbGV0ZWRObycsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdObycsXG4gIH0sXG4gIG51bWJlck9mQnJhbmRQYXJ0bmVyczoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIubnVtYmVyT2ZCcmFuZFBhcnRuZXJzJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ051bWJlciBvZiBCcmFuZCBQYXJ0bmVycycsXG4gIH0sXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/EventDetailsTab/EventDetailsTab.messages.js
// module id = 2164
// module chunks = 0